/* eslint-disable jira/filename-case */
import { PROJECT_SETTINGS_NAVIGATION_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-id.tsx';
import {
	FIXED_ITEM,
	type ComponentType,
} from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';

export const MENU_ID_JSM_SETTINGS = 'project/service-desk/settings';

const COMMON_ANALYTICS_ATTRIBUTES: { componentType: ComponentType; level: number } = {
	componentType: FIXED_ITEM,
	level: 1,
};

// prefer getProjectSettingsMenuItemAnalytics(), as it specifies required and optional attributes you can pass (e.g. itemId, parentItemId).
export const PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES: {
	actionSubjectId: string;
	componentType: ComponentType;
	level: number;
} = {
	...COMMON_ANALYTICS_ATTRIBUTES,
	actionSubjectId: PROJECT_SETTINGS_NAVIGATION_ITEM,
};
